<template>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Neuen Benutzer hinzufügen</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="create">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <userform ref="UForm"/>

                    <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Benutzer anlegen</span></button>
                </form>
                <router-link :to="{ name: 'user_invite'}">Der Nutzer hat bereits einen Socialguard Account? Fügen Sie einen bestehenden Nutzer zu Ihrer Organisation hinzu.</router-link>
            </template>
        </card>
</template>

<script>
    import Userform from "@/views/Users/Userform";

    export default {
        name: "create",
        components: {Userform},
        data() {
            return {
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        methods: {
            create() {
                if (this.$refs.UForm.locCheck) {
                    this.status = { type: "warning", msg: "Bitte geben Sie den Standort für diesen Benutzer an."}
                    window.scrollTo(0, 0);
                } else {
                    this.isLoading = true;
                    this.createUser()
                        .then(response => {
                            this.isLoading = false;
                            this.status =  {type: 'success', msg: 'Benutzer (ID: '+response.id+') wurde erstellt. Das Passwort wurde per E-Mail versendet.'};
                            this.$store.dispatch('alert/success',this.status.msg);
                            this.$router.push('/users');
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.status =  {type: 'danger', msg: error};
                        })
                }
            },
            createUser() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.$refs.UForm.user;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

